import React, { createContext, useContext, useState, useEffect } from 'react';
import useAuthFetch from '../hooks/useAuthFetch';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const authFetch = useAuthFetch();
  const [userRole, setUserRole] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const checkUserRole = async () => {
    try {
      const response = await authFetch('/api/v1/whoami');
      if (response.ok) {
        const data = await response.json();
        setUserData(data);
        setUserRole(data.type || 'client'); // Default to client if no role specified
        localStorage.setItem('userData', JSON.stringify(data));
      } else {
        setUserRole(null);
        setUserData(null);
        localStorage.removeItem('userData');
      }
    } catch (error) {
      console.error('Failed to check user role:', error);
      setUserRole(null);
      setUserData(null);
      localStorage.removeItem('userData');
    } finally {
      setIsLoading(false);
    }
  };

  const isAdmin = () => userRole === 'admin';
  const isClient = () => userRole === 'client';

  useEffect(() => {
    // Check user role on mount
    checkUserRole();
  }, []);

  console.log('userRole', userRole);

  return (
    <AuthContext.Provider value={{ 
      authFetch, 
      userRole, 
      userData, 
      isAdmin, 
      isClient, 
      checkUserRole,
      isLoading
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 